import { call, put, takeLatest } from 'redux-saga/effects';
import Swal from 'sweetalert2';

import * as communicationCenterService from '../services/ContentManagementServices';
import * as types from './ContentManagementActionType';
import * as actions from './ContentManagementActions';

// 1. Get All Communications
function* getAllCommunicationsSaga(action) {
  try {
    const response = yield call(communicationCenterService.getAllCommunications, action.payload);
    yield put(actions.getAllCommunicationsSuccess({
      communicationsDataList: response?.data?.communicationsDataList || [],
      totalRecords: response?.data?.totalRecords || 0,
    }));
  } catch (error) {
    yield put(actions.getAllCommunicationsFailure(error));
    Swal.fire('Error', error?.message || 'Failed to fetch communications.', 'error');
  }
}

// 2. Enable/Disable Communications
function* enableDisableCommunicationsSaga(action) {
  try {
    const { refetchPayload, ...enableDisablePayload } = action.payload || {};
    const response = yield call(communicationCenterService.enableDisableCommunications, enableDisablePayload);
    yield put(actions.enableDisableCommunicationsSuccess(response));
    // Re-request the list with the pagination state that was active when the toggle was clicked,
    // instead of no payload (which fell back to the API's default page size).
    yield put(actions.getAllCommunicationsRequestAction(refetchPayload));
    Swal.fire('Success', 'Status updated successfully.', 'success');
  } catch (error) {
    yield put(actions.enableDisableCommunicationsFailure(error));
    Swal.fire('Error', error?.message || 'Failed to update status.', 'error');
  }
}

// 4. Get Communications Document Type For Dropdown
function* getCommunicationsDocumentTypeForDropdownSaga(action) {
  try {
    const response = yield call(communicationCenterService.getCommunicationsDocumentTypeForDropdown, action.payload);
    yield put(actions.getCommunicationsDocumentTypeForDropdownSuccess(response));
  } catch (error) {
    yield put(actions.getCommunicationsDocumentTypeForDropdownFailure(error));
    Swal.fire('Error', error?.message || 'Failed to fetch document types.', 'error');
  }
}

// Watcher Saga
export default function* communicationCenterWatcherSaga() {
  yield takeLatest(types.GET_ALL_COMMUNICATIONS_REQUEST, getAllCommunicationsSaga);
  yield takeLatest(types.ENABLE_DISABLE_COMMUNICATIONS_REQUEST, enableDisableCommunicationsSaga);
  yield takeLatest(types.GET_COMMUNICATIONS_DOCUMENT_TYPE_DROPDOWN_REQUEST, getCommunicationsDocumentTypeForDropdownSaga);
}

